import React from "react";

import "./HealthCare.scss";
import MegaHeader from "../MegaHeader";

const HealthCare = () => {
  const dashboardUrl = "https://medical-intelligence-hub.lovable.app";

  return (
    <> 
    
       <MegaHeader />
    <div className="design-dashboard">
      <iframe
        key={1}
        src={dashboardUrl}
        className="design-dashboard__iframe"
        title="Design Dashboard"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
    </>
  
  );
};

export default HealthCare;
